import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/// <reference path="../../../types.d.ts" />
import { FlexCard } from '@codametrix/ui-components';
import React, { useState } from 'react';
import ReactJson from 'react-json-view';
import { appServiceLines } from '@codametrix/ui-common';
import { ProcessSelection } from '@codametrix/shared-views';
import './case-json.scss';
import { sortCaseRuns } from '../../../reducers/cases.reducer';
const DISPLAY_ORDER = {
    ALPHA: 'alpha',
    ORIGINAL: 'original'
};
const CaseJson = (props)=>{
    const { caseDetail, activeCaseRun, onClick } = props;
    let activeCaseJson;
    if ('casejson' in activeCaseRun) {
        activeCaseJson = activeCaseRun.casejson;
    } else {
        activeCaseJson = activeCaseRun;
    }
    const [displayInfo, setDisplay] = useState({
        displayOrder: 'original',
        collapsed: true
    });
    const isAlphaSort = displayInfo.displayOrder === DISPLAY_ORDER.ALPHA;
    const handleToggleOrder = (event)=>{
        event.preventDefault();
        setDisplay({
            ...displayInfo,
            displayOrder: displayInfo.displayOrder === DISPLAY_ORDER.ALPHA ? DISPLAY_ORDER.ORIGINAL : DISPLAY_ORDER.ALPHA
        });
    };
    const handleToggleAll = (event)=>{
        event.preventDefault();
        setDisplay({
            ...displayInfo,
            collapsed: !displayInfo.collapsed
        });
    };
    let toDisplay = {};
    if (isAlphaSort) {
        const sortedKeys = Object.keys(activeCaseJson).sort();
        sortedKeys.forEach((key)=>{
            //@ts-ignore
            toDisplay[key] = activeCaseJson[key];
        });
    } else {
        toDisplay = activeCaseJson;
    }
    const sortedCaseRuns = sortCaseRuns(caseDetail, {});
    const json = /*#__PURE__*/ _jsx(ReactJson, {
        src: toDisplay,
        displayObjectSize: false,
        collapsed: displayInfo.collapsed ? 3 : false,
        displayDataTypes: false,
        theme: 'ocean'
    });
    let accessionNumber = '';
    let accessionIssuer = '';
    if ('hospital_account_record' in activeCaseJson && appServiceLines.isIPC(activeCaseJson.service_line)) {
        accessionNumber = //@ts-ignore
        'Hospital Account Record: ' + activeCaseJson.hospital_account_record;
    } else {
        accessionNumber = 'Accession: ' + activeCaseJson.primary_clinical_identifier.number;
        accessionIssuer = '(' + activeCaseJson.primary_clinical_identifier.issuer + ')';
    }
    const header = /*#__PURE__*/ _jsxs("div", {
        className: "case-json-header cols",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "col-7",
                children: /*#__PURE__*/ _jsxs("h5", {
                    children: [
                        accessionNumber,
                        accessionIssuer
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "col-5 display-controls",
                children: [
                    "showing",
                    ' ',
                    /*#__PURE__*/ _jsx("a", {
                        href: "#/toggle",
                        className: 'qa-toggle-order',
                        onClick: handleToggleOrder,
                        children: !isAlphaSort ? 'original' : 'A-Z'
                    }),
                    ' ',
                    '  ',
                    /*#__PURE__*/ _jsx("a", {
                        href: "#/toggle",
                        "data-testid": "qa-toggle-all",
                        className: 'qa-toggle-all',
                        onClick: handleToggleAll,
                        children: !displayInfo.collapsed ? 'expanded' : 'summary'
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        children: /*#__PURE__*/ _jsx(ProcessSelection, {
                            caseRuns: sortedCaseRuns,
                            activeId: activeCaseJson.process_instance_id,
                            onClick: onClick
                        })
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ _jsx("div", {
        "data-testid": "case-json-view",
        className: "case-json-view",
        children: /*#__PURE__*/ _jsx(FlexCard, {
            header: header,
            className: 'case-json-card',
            children: /*#__PURE__*/ _jsx("div", {
                children: json
            })
        })
    });
};
export { CaseJson };
